// Vendors
import { TrackingUserStatusEnum, TrackingUserTypeEnum } from '@openbank/cf-ui-static-data';

const TRACKING_CONFIGURATION = {
  userType: TrackingUserTypeEnum.CLIENT,
  userStatus: TrackingUserStatusEnum.LOGGEDIN,
};
const TRACKING_CUSTOM_CONFIGURATION = { userMarket: 'DE', webArea: 'private' };

const APP_TRACKING_CONFIGURATION_PAGENAME = {
  ACTIVATE: 'activateCard',
  CARD_SETTINGS: 'cardSettings',
  DASHBOARD: 'dashboard',
  FINANCING: 'financing',
  POINTS: 'points',
  REPORT_A_PROBLEM: 'reportAProblem',
  SUPPORT: 'support',
  TRANSACTIONS: 'transactions',
};

export {
  APP_TRACKING_CONFIGURATION_PAGENAME,
  TRACKING_CONFIGURATION,
  TRACKING_CUSTOM_CONFIGURATION,
};
